const style = {
  wrapper: {
    minHeight: `40px`
  },
  content: {
    height: `100%`
  },
  list: {
    listStyle: `none`,
    margin: 0,
    padding: 0
  },
  listItem: {},
  listItemLink: {
    padding: `5px 10px`,
    textDecoration: `none`,
    fontSize: `13px`,
    color: `#A94545`,
    ':hover': {
      background: `#eee`
    }
  },
  listItemIcon: {
    marginRight: `2px`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/partials/Header/style/authbar.js